import { Alert, Button, Modal } from 'react-bootstrap';

import { PraSection } from '../../../../../../__gqltypes__';
import { PRA_CONFIG_CHANGE_NOTICE, PRA_SECTION_LABELS } from '../utils';

type Props = {
  show: boolean;
  section: PraSection;
  // No config saved yet: nobody can be mid-cycle — a plain confirm.
  isNewConfig: boolean;
  maintenance: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

// Confirmation modal on every save (MarathonEventData pattern). Informational only: the D8 safe-to-edit
// rule, its hard warning and "Save anyway" are gone — the modal states what players experience and confirms.
export function PraSaveConfirmModal({
  show,
  section,
  isNewConfig,
  maintenance,
  onCancel,
  onConfirm,
}: Props): JSX.Element {
  const label = PRA_SECTION_LABELS[section];

  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title as="h5">{`Save ${label} configuration`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isNewConfig && (
          <Alert variant="info">
            This creates the section&apos;s first configuration — no players can be mid-cycle yet.
          </Alert>
        )}
        {!isNewConfig && (
          <>
            <Alert variant="info">{PRA_CONFIG_CHANGE_NOTICE}</Alert>
            <p className="text-muted">{`Maintenance is currently ${maintenance ? 'ON' : 'OFF'} for ${label}.`}</p>
          </>
        )}
        <p className="mb-0">
          Saving fully replaces the <strong>{label}</strong> section configuration on the server.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
